// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath fill=%27%23ffffff%27 d=%27M6 8L0 0h12z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    background-color: #121212;
}

.wrapper {
    padding: 20px;
}

.header {
    margin: 10px;
    background-color: #1e1e1e;
    border: 1px solid var(--wire-purple);
    border-radius: 10px;
    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);
}

p {
    margin: 10px;
}

.toolbar {
    background-color: #2d2d2d;
}

* {
    font-size: 16px;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: sans-serif;
    color: white;
  }
  
  .App {
    font-family: sans-serif;
    text-align: center;
  }
  
  .app-background {
    background-color: #1a1a1a;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }
  
  .main-shopping-container {
    background-color: var(--surface-bg);
    width: min(100%, 760px);
    height: min-content;
    border-radius: 16px;
    padding: 24px;
    border: 1px solid var(--wire-green);
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 10px 10px 26px 0px rgba(0, 0, 0, 0.35);
  }

  .shopping-page {
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  .shopping-header {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    justify-content: space-between;
    gap: 14px;
  }

  .shopping-summary {
    display: flex;
    flex: 1 1;
    min-width: 220px;
    flex-direction: column;
    gap: 10px;
  }

  .selected-list-title {
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 0;
    padding: 14px 16px;
    background-color: var(--panel-bg);
    border: 1px solid var(--wire-green);
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
    border-radius: 12px;
    min-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .main-item-container {
    background-color: var(--panel-bg);
    height: min-content;
    border-radius: 14px;
    padding: 20px;
    border: 1px solid var(--wire-teal);
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 10px 10px 26px 0px rgba(0, 0, 0, 0.35);
  }

  .shopping-items-panel {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .title {
    text-align: center;
  }
  
  .add-item-box {
    background: var(--panel-bg);
    color: #ffffff;
    margin-top: 1em;
    margin-bottom: 1em;
    display: flex;
    align-items: center;
    border-radius: 10px;
    padding: 5px;
    border: 1px solid var(--wire-green);
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
    transition: all 0.2s ease;
  }

  .add-item-box:focus-within {
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
  }

  .shopping-add-item-box {
    margin-top: 0;
    padding: 6px 8px 6px 14px;
  }

  /* When a field has an explicit label above it, use tighter spacing */
  .add-item-box--field {
    margin-top: 0;
    margin-bottom: 12px;
  }
  
  .add-item-box svg {
    margin: 5px;
  }
  
  .add-item-input {
    box-sizing: border-box;
    border: none;
    background: transparent;
    color: #ffffff;
    width: 100%;
    height: 30px;
  }

  select.add-item-input {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    cursor: pointer;
    padding-right: 24px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 12px;
  }

  select.add-item-input option {
    background: #424242;
    color: #ffffff;
    padding: 8px;
  }
  
  input::placeholder {
    color: #cccccc;
  }
  input:focus {
    outline: 0;
  }
  
  .item-list {
    display: flex;
    flex-direction: column;
  }
  
  .item-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 0;
    border-bottom: 1px #555555 solid;
  }

  .item-div {
    height: 400px;
    overflow-y: auto;
  }

  .list-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0 20px 0;
    border-bottom: 1px #555555 solid;
    width: 150px;
  }
  
  .item-name {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1 1;
    min-width: 0;
    word-break: break-word;
  }

  .item-details {
    display: flex;
    cursor: pointer;
    align-items: center;
    gap: 10px;
  }

  .shopping-item-details {
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  .delete {
    display: flex;
    float: right;
  }

  .delete-color {
    color: #dc3545;
  }

  .vault-add-button {
    cursor: pointer;
  }

  .vault-item-row {
    align-items: center;
    gap: 10px;
    padding: 10px 0;
  }

  .vault-item-main {
    flex: 1 1;
    min-width: 0;
  }

  .vault-item-trigger {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
    color: #ffffff;
    cursor: pointer;
  }

  .vault-item-name-row {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .vault-item-name-row span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 1.25;
  }

  .vault-tag {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    font-size: 11px;
    line-height: 1.4;
    color: #adb5bd;
    background: rgba(255, 255, 255, 0.08);
    border-radius: 4px;
    white-space: nowrap;
    width: fit-content;
  }

  .vault-item-actions {
    align-items: center;
    gap: 0;
    margin-left: 0;
  }

  .vault-delete-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    min-width: 36px;
    min-height: 36px;
    padding: 0;
    margin: 0;
    color: var(--wire-red);
    border: 1px solid var(--wire-red);
    border-radius: 8px;
    background: var(--btn-bg);
    transition: all 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
  }

  .vault-delete-button:hover {
    background: var(--btn-bg-hover);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);
  }

  .vault-search-box {
    margin-bottom: 4px;
  }

  .vault-manage-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 8px;
  }

  .vault-settings-menu {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding-top: 8px;
  }

  .vault-settings-action {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    min-height: 44px;
    padding: 10px 12px;
    margin: 0;
    background: var(--btn-bg);
    border: 1px solid var(--wire-blue);
    border-radius: 8px;
    color: #ffffff;
    text-align: left;
    transition: all 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);
  }

  .vault-settings-action:hover {
    background: var(--btn-bg-hover);
    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);
  }

  .vault-settings-action:disabled {
    cursor: default;
    opacity: 0.55;
    transform: none;
    box-shadow: none;
  }

  .vault-danger-zone {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    border: 1px solid var(--wire-red);
    border-radius: 8px;
    background: var(--panel-bg);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
  }

  .vault-danger-zone div div {
    color: #cccccc;
    font-size: 13px;
    margin-top: 2px;
  }

  /* Vault: keep selector + Add Vault on one row */
  .add-item-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .add-item-container > label {
    margin: 0;
    white-space: nowrap;
  }

  .add-item-container select.add-item-box {
    flex: 1 1;
    min-width: 0;
    margin-top: 0;
    margin-bottom: 0;
  }

  .add-item-container .vault-add-button {
    margin-left: auto;
    flex-shrink: 0;
  }

  .field-label {
    display: block;
    margin: 8px 0 2px;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #cccccc;
    line-height: 1.1;
  }

  .field-label--inline {
    display: inline-block;
    margin: 0 8px 0 0;
    white-space: nowrap;
  }

  .field-stack {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
    background: var(--panel-bg);
    border: 1px solid var(--wire-green);
    border-radius: 10px;
    padding: 8px 10px;
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
    transition: all 0.2s ease;
  }

  .field-stack:focus-within {
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
  }

  .field-stack .field-label {
    margin-top: 0;
    margin-bottom: 2px;
  }

  .field-stack .add-item-box--field {
    margin-bottom: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 2px 0;
  }
  
  .item-name svg {
    margin-left: 5px;
    margin-right: 5px;
  }
  
  .item-action-buttons {
    /* width: 30%; */
    display: flex;
    justify-content: space-between;
  }
  
  .remove-button {
    color: white;
    background-color: #000000;
  }
  
  .total {
    float: right;
    padding: 10px;
  }

  .shopping-total {
    float: none;
    align-self: flex-end;
    padding: 10px 14px;
    background: #383838;
    border-radius: 999px;
    color: #f1f1f1;
    font-weight: 600;
  }
  
  .quantity {
    display: flex;
    align-items: center;
    border: 1px solid var(--wire-teal);
    background: var(--panel-bg);
    border-radius: 50px;
    font-size: 12px;
    color: #ffffff;
    min-width: 92px;
    padding: 2px 6px;
    justify-content: space-between;
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);
  }

  .shopping-quantity {
    gap: 4px;
  }

  .quantity-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    min-width: 26px;
    min-height: 26px;
    margin: 0;
    border-radius: 999px;
    background: var(--btn-bg);
    color: var(--wire-teal);
    border: 1px solid var(--wire-teal);
    transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);
  }

  .quantity-button:hover {
    background: var(--btn-bg-hover);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 0 0 10px rgba(168, 240, 247, 0.4);
  }

  .quantity-value {
    min-width: 18px;
    text-align: center;
    font-weight: 600;
  }

  .shopping-add-button,
  .shopping-delete-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
    margin: 0;
    border-radius: 10px;
    background: var(--btn-bg);
    border: 1px solid var(--wire-green);
    color: var(--wire-green);
    transition: all 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);
  }

  .shopping-add-button:hover {
    background: var(--btn-bg-hover);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);
  }

  .shopping-delete-button {
    border-color: var(--wire-red);
    color: var(--wire-red);
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
  }

  .shopping-delete-button:hover {
    background: var(--btn-bg-hover);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);
  }

  .shopping-empty-state {
    padding: 28px 18px;
    text-align: center;
    color: #cccccc;
    background: var(--panel-bg);
    border: 1px dashed var(--wire-green);
    border-radius: 12px;
    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.12);
  }

  .settings-page {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .settings-header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 18px;
  }

  .settings-header h2 {
    margin: 0;
    color: #ffffff;
  }

  .settings-subtitle {
    color: #cccccc;
    overflow-wrap: anywhere;
  }

  .settings-section {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 14px;
    margin-top: 12px;
    background: var(--panel-bg);
    border: 1px solid var(--wire-purple);
    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);
    border-radius: 8px;
  }

  .settings-section-title {
    color: #ffffff;
    font-weight: 700;
  }

  .settings-info-row {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    color: #cccccc;
  }

  .settings-info-row strong {
    color: #ffffff;
    text-align: right;
    overflow-wrap: anywhere;
  }

  .settings-action-link,
  .settings-action-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 42px;
    padding: 9px 12px;
    margin: 0;
    color: #ffffff;
    background: var(--btn-bg);
    border: 1px solid var(--wire-purple);
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);
  }

  .settings-action-button:hover {
    background: var(--btn-bg-hover);
    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);
  }

  .settings-action-button:disabled {
    cursor: default;
    opacity: 0.55;
    transform: none;
    box-shadow: none;
  }

  .settings-danger-action {
    background: rgba(244, 67, 54, 0.18);
  }

  .vault-management-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 10px;
    align-items: center;
  }

  .vault-management-row .add-item-box--field {
    margin-bottom: 0;
  }

  .vault-shared-user-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .vault-shared-user-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px;
    background: #424242;
    border-radius: 8px;
  }

  .vault-shared-user-row strong {
    color: #ffffff;
  }

  .vault-shared-user-row div div {
    color: #cccccc;
    font-size: 12px;
    overflow-wrap: anywhere;
  }

  .vault-owner-pill,
  .vault-remove-share-button {
    flex-shrink: 0;
    padding: 6px 9px;
    margin: 0;
    border-radius: 999px;
    font-size: 12px;
  }

  .vault-owner-pill {
    background: rgba(76, 175, 80, 0.18);
    color: #a5d6a7;
  }

  .vault-remove-share-button {
    background: var(--btn-bg);
    border: 1px solid var(--wire-red);
    color: var(--wire-red);
    transition: all 0.2s ease;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);
  }

  .vault-remove-share-button:hover {
    background: var(--btn-bg-hover);
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);
  }
  
  button {
    background: transparent;
    border: none;
    margin: 3px;
    color: #ffffff;
  }
  button:focus {
    outline: 0;
  }
  
  button:hover {
    cursor: pointer;
  }
  
  .completed {
    text-decoration: line-through;
  }

  .amount {
    display: flex;
    align-items: center;
    border: 1px solid var(--wire-teal);
    background: var(--panel-bg);
    border-radius: 50px;
    font-size: 12px;
    color: #ffffff;
    min-width: 70px;
    justify-content: center;
    float: left;
    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);
  }

  .shopping-amount {
    min-width: 84px;
    padding: 0 10px;
  }

  .list-name {
    background: #333333;
  }

/* Responsive Design */
@media (max-width: 768px) {
  * {
    font-size: 18px;
  }

  .app-background {
    padding: 10px;
    min-height: 100vh;
  }

  .main-shopping-container {
    width: 100%;
    max-width: 720px;
    padding: 16px;
    margin: 0 auto;
  }

  .main-item-container {
    padding: 15px;
  }

  .item-container {
    padding: 14px 0;
    gap: 12px;
    align-items: flex-start;
  }

  .vault-item-row {
    flex-direction: row;
    align-items: center;
    padding: 10px 0;
  }

  .item-details {
    flex-shrink: 0;
    margin-left: auto;
  }

  .delete {
    float: none;
  }

  .grid-template-columns {
    grid-template-columns: 1fr;
  }

  .toolbar {
    padding: 8px 16px;
  }

  .header h6 {
    font-size: 16px;
  }

  .shopping-header {
    flex-direction: column;
  }

  .shopping-summary {
    min-width: 0;
  }

  .shopping-total {
    align-self: stretch;
    text-align: center;
  }
}

@media (max-width: 480px) {
  * {
    font-size: 16px;
  }

  .main-shopping-container {
    padding: 12px;
    border-radius: 12px;
  }

  .main-item-container {
    padding: 12px;
  }

  .add-item-box {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .item-container {
    padding: 12px 0;
    flex-direction: column;
    align-items: stretch;
  }

  .vault-item-row {
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 9px 0;
  }

  .vault-item-actions {
    width: auto;
    margin-left: auto;
  }

  .vault-delete-button {
    width: 34px;
    height: 34px;
    min-width: 34px !important;
    min-height: 34px !important;
  }

  .vault-danger-zone {
    flex-direction: column;
    align-items: stretch;
  }

  .settings-info-row,
  .vault-management-row {
    grid-template-columns: 1fr;
  }

  .vault-shared-user-row {
    align-items: flex-start;
  }

  .settings-info-row {
    flex-direction: column;
    gap: 2px;
  }

  .settings-info-row strong {
    text-align: left;
  }

  .quantity, .amount {
    min-width: 60px;
    font-size: 11px;
  }

  .shopping-item-details {
    width: 100%;
    justify-content: space-between;
  }

  .quantity-button {
    width: 30px;
    height: 30px;
    min-width: 30px !important;
    min-height: 30px !important;
  }

  .shopping-add-button,
  .shopping-delete-button {
    width: 34px;
    height: 34px;
    min-width: 34px !important;
    min-height: 34px !important;
  }

  .selected-list-title {
    font-size: 18px;
    padding: 12px;
  }

  .toolbar {
    padding: 4px 8px;
  }

  .header {
    margin: 5px;
  }
}

@media (min-width: 1200px) {
  .main-shopping-container {
    width: min(100%, 920px);
  }

  .main-item-container {
    padding: 25px;
  }

  .item-container {
    padding: 18px 0;
  }
}

/* Flexbox improvements for better responsiveness */
.app-background {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
}

@media (max-width: 768px) {
  .app-background {
    padding: 10px;
    align-items: stretch;
  }
}

/* Grid improvements for user management */
.grid-template-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 10px;
}

.user-edit-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding-top: 8px;
}

.user-edit-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}

.user-vault-picker {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 8px;
  max-height: 180px;
  overflow-y: auto;
  padding: 8px;
  background: #333333;
  border: 1px solid #555555;
  border-radius: 8px;
}

.user-vault-option,
.user-access-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
}

.user-vault-option {
  min-height: 38px;
  padding: 8px 10px;
  background: #424242;
  border-radius: 8px;
}

.user-vault-option span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-access-toggle {
  align-self: flex-start;
  min-height: 40px;
}

.user-empty-note {
  color: #cccccc;
  font-size: 13px;
  padding: 8px;
}

@media (max-width: 768px) {
  .grid-template-columns {
    grid-template-columns: 1fr;
  }

  .user-edit-grid {
    grid-template-columns: 1fr;
    gap: 0;
  }

  .user-vault-picker {
    grid-template-columns: 1fr;
    max-height: 220px;
  }
}

/* User Management specific responsive styles */
@media (max-width: 768px) {
  .user-item-container {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 15px !important;
  }

  .user-item-buttons {
    width: 100% !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    gap: 8px !important;
  }

  .user-item-buttons button {
    flex: 1 1 !important;
    min-width: 120px !important;
  }
}

/* Button responsiveness */
.vault-add-button, button {
  transition: all 0.2s ease;
}

.vault-add-button:hover, button:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

/* Form input improvements */
.add-item-input:focus {
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* Loading spinner responsiveness */
@media (max-width: 480px) {
  .MuiCircularProgress-root {
    width: 40px !important;
    height: 40px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/App/App.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,oCAAoC;IACpC,mBAAmB;IACnB,qDAAqD;AACzD;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,mCAAmC;IACnC,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,mCAAmC;IACnC,6FAA6F;EAC/F;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,8BAA8B;IAC9B,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAO;IACP,gBAAgB;IAChB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,iCAAiC;IACjC,mCAAmC;IACnC,qDAAqD;IACrD,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,6FAA6F;EAC/F;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,mCAAmC;IACnC,qDAAqD;IACrD,yBAAyB;EAC3B;;EAEA;IACE,wFAAwF;EAC1F;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA,qEAAqE;EACrE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,yDAAwL;IACxL,4BAA4B;IAC5B,qCAAqC;IACrC,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gCAAgC;IAChC,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,SAAO;IACP,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,MAAM;IACN,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,wFAAwF;EAC1F;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,kCAAkC;IAClC,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,wFAAwF;EAC1F;;EAEA;IACE,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,qDAAqD;EACvD;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA,gDAAgD;EAChD;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,iBAAiB;IACjB,qDAAqD;IACrD,yBAAyB;EAC3B;;EAEA;IACE,wFAAwF;EAC1F;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,qDAAqD;EACvD;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,yBAAyB;IACzB,uBAAuB;IACvB,kCAAkC;IAClC,iFAAiF;IACjF,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,wFAAwF;EAC1F;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,mCAAmC;IACnC,wBAAwB;IACxB,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,wFAAwF;EAC1F;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,wFAAwF;EAC1F;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,oCAAoC;IACpC,mBAAmB;IACnB,qDAAqD;EACvD;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,oCAAoC;IACpC,qDAAqD;IACrD,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,uBAAuB;EACzB;;EAEA;;IAEE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,yBAAyB;IACzB,oCAAoC;IACpC,kBAAkB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,wFAAwF;EAC1F;;EAEA;IACE,eAAe;IACf,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,aAAa;IACb,0CAA0C;IAC1C,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,uBAAuB;EACzB;;EAEA;;IAEE,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,oBAAoB;IACpB,eAAe;EACjB;;EAEA;IACE,mCAAmC;IACnC,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,iCAAiC;IACjC,sBAAsB;IACtB,yBAAyB;IACzB,qDAAqD;EACvD;;EAEA;IACE,+BAA+B;IAC/B,cAAc;IACd,wFAAwF;EAC1F;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,cAAc;EAChB;EACA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,qDAAqD;EACvD;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;AAEF,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;AACF;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;;EAEA;IACE,0BAA0B;IAC1B,iBAAiB;EACnB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,iCAAiC;IACjC,kCAAkC;IAClC,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,kCAAkC;IAClC,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;EAC7B;AACF;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,mCAAmC;AACnC;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".app {\n    background-color: #121212;\n}\n\n.wrapper {\n    padding: 20px;\n}\n\n.header {\n    margin: 10px;\n    background-color: #1e1e1e;\n    border: 1px solid var(--wire-purple);\n    border-radius: 10px;\n    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);\n}\n\np {\n    margin: 10px;\n}\n\n.toolbar {\n    background-color: #2d2d2d;\n}\n\n* {\n    font-size: 16px;\n  }\n  \n  body {\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif;\n    color: white;\n  }\n  \n  .App {\n    font-family: sans-serif;\n    text-align: center;\n  }\n  \n  .app-background {\n    background-color: #1a1a1a;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n  }\n  \n  .main-shopping-container {\n    background-color: var(--surface-bg);\n    width: min(100%, 760px);\n    height: min-content;\n    border-radius: 16px;\n    padding: 24px;\n    border: 1px solid var(--wire-green);\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 10px 10px 26px 0px rgba(0, 0, 0, 0.35);\n  }\n\n  .shopping-page {\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n  }\n\n  .shopping-header {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: stretch;\n    justify-content: space-between;\n    gap: 14px;\n  }\n\n  .shopping-summary {\n    display: flex;\n    flex: 1;\n    min-width: 220px;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .selected-list-title {\n    text-align: center;\n    color: #ffffff;\n    font-size: 20px;\n    font-weight: bold;\n    margin-bottom: 0;\n    padding: 14px 16px;\n    background-color: var(--panel-bg);\n    border: 1px solid var(--wire-green);\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n    border-radius: 12px;\n    min-height: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .main-item-container {\n    background-color: var(--panel-bg);\n    height: min-content;\n    border-radius: 14px;\n    padding: 20px;\n    border: 1px solid var(--wire-teal);\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 10px 10px 26px 0px rgba(0, 0, 0, 0.35);\n  }\n\n  .shopping-items-panel {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .title {\n    text-align: center;\n  }\n  \n  .add-item-box {\n    background: var(--panel-bg);\n    color: #ffffff;\n    margin-top: 1em;\n    margin-bottom: 1em;\n    display: flex;\n    align-items: center;\n    border-radius: 10px;\n    padding: 5px;\n    border: 1px solid var(--wire-green);\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n    transition: all 0.2s ease;\n  }\n\n  .add-item-box:focus-within {\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n  }\n\n  .shopping-add-item-box {\n    margin-top: 0;\n    padding: 6px 8px 6px 14px;\n  }\n\n  /* When a field has an explicit label above it, use tighter spacing */\n  .add-item-box--field {\n    margin-top: 0;\n    margin-bottom: 12px;\n  }\n  \n  .add-item-box svg {\n    margin: 5px;\n  }\n  \n  .add-item-input {\n    box-sizing: border-box;\n    border: none;\n    background: transparent;\n    color: #ffffff;\n    width: 100%;\n    height: 30px;\n  }\n\n  select.add-item-input {\n    appearance: none;\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    cursor: pointer;\n    padding-right: 24px;\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23ffffff' d='M6 8L0 0h12z'/%3E%3C/svg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 8px center;\n    background-size: 12px;\n  }\n\n  select.add-item-input option {\n    background: #424242;\n    color: #ffffff;\n    padding: 8px;\n  }\n  \n  input::placeholder {\n    color: #cccccc;\n  }\n  input:focus {\n    outline: 0;\n  }\n  \n  .item-list {\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .item-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 16px 0;\n    border-bottom: 1px #555555 solid;\n  }\n\n  .item-div {\n    height: 400px;\n    overflow-y: auto;\n  }\n\n  .list-container {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px 0 20px 0;\n    border-bottom: 1px #555555 solid;\n    width: 150px;\n  }\n  \n  .item-name {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: 1;\n    min-width: 0;\n    word-break: break-word;\n  }\n\n  .item-details {\n    display: flex;\n    cursor: pointer;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .shopping-item-details {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n\n  .delete {\n    display: flex;\n    float: right;\n  }\n\n  .delete-color {\n    color: #dc3545;\n  }\n\n  .vault-add-button {\n    cursor: pointer;\n  }\n\n  .vault-item-row {\n    align-items: center;\n    gap: 10px;\n    padding: 10px 0;\n  }\n\n  .vault-item-main {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .vault-item-trigger {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n    color: #ffffff;\n    cursor: pointer;\n  }\n\n  .vault-item-name-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-width: 0;\n  }\n\n  .vault-item-name-row span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    line-height: 1.25;\n  }\n\n  .vault-tag {\n    display: inline-flex;\n    align-items: center;\n    padding: 2px 8px;\n    font-size: 11px;\n    line-height: 1.4;\n    color: #adb5bd;\n    background: rgba(255, 255, 255, 0.08);\n    border-radius: 4px;\n    white-space: nowrap;\n    width: fit-content;\n  }\n\n  .vault-item-actions {\n    align-items: center;\n    gap: 0;\n    margin-left: 0;\n  }\n\n  .vault-delete-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    min-height: 36px;\n    padding: 0;\n    margin: 0;\n    color: var(--wire-red);\n    border: 1px solid var(--wire-red);\n    border-radius: 8px;\n    background: var(--btn-bg);\n    transition: all 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n  }\n\n  .vault-delete-button:hover {\n    background: var(--btn-bg-hover);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);\n  }\n\n  .vault-search-box {\n    margin-bottom: 4px;\n  }\n\n  .vault-manage-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    padding-top: 8px;\n  }\n\n  .vault-settings-menu {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-top: 8px;\n  }\n\n  .vault-settings-action {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    min-height: 44px;\n    padding: 10px 12px;\n    margin: 0;\n    background: var(--btn-bg);\n    border: 1px solid var(--wire-blue);\n    border-radius: 8px;\n    color: #ffffff;\n    text-align: left;\n    transition: all 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18);\n  }\n\n  .vault-settings-action:hover {\n    background: var(--btn-bg-hover);\n    box-shadow: inset 0 0 0 1px rgba(168, 216, 255, 0.18), 0 0 10px rgba(168, 216, 255, 0.4);\n  }\n\n  .vault-settings-action:disabled {\n    cursor: default;\n    opacity: 0.55;\n    transform: none;\n    box-shadow: none;\n  }\n\n  .vault-danger-zone {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px;\n    border: 1px solid var(--wire-red);\n    border-radius: 8px;\n    background: var(--panel-bg);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n  }\n\n  .vault-danger-zone div div {\n    color: #cccccc;\n    font-size: 13px;\n    margin-top: 2px;\n  }\n\n  /* Vault: keep selector + Add Vault on one row */\n  .add-item-container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n\n  .add-item-container > label {\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  .add-item-container select.add-item-box {\n    flex: 1;\n    min-width: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .add-item-container .vault-add-button {\n    margin-left: auto;\n    flex-shrink: 0;\n  }\n\n  .field-label {\n    display: block;\n    margin: 8px 0 2px;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n    color: #cccccc;\n    line-height: 1.1;\n  }\n\n  .field-label--inline {\n    display: inline-block;\n    margin: 0 8px 0 0;\n    white-space: nowrap;\n  }\n\n  .field-stack {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    width: 100%;\n    background: var(--panel-bg);\n    border: 1px solid var(--wire-green);\n    border-radius: 10px;\n    padding: 8px 10px;\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n    transition: all 0.2s ease;\n  }\n\n  .field-stack:focus-within {\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n  }\n\n  .field-stack .field-label {\n    margin-top: 0;\n    margin-bottom: 2px;\n  }\n\n  .field-stack .add-item-box--field {\n    margin-bottom: 0;\n    background: transparent;\n    border: none;\n    box-shadow: none;\n    padding: 2px 0;\n  }\n  \n  .item-name svg {\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n  \n  .item-action-buttons {\n    /* width: 30%; */\n    display: flex;\n    justify-content: space-between;\n  }\n  \n  .remove-button {\n    color: white;\n    background-color: #000000;\n  }\n  \n  .total {\n    float: right;\n    padding: 10px;\n  }\n\n  .shopping-total {\n    float: none;\n    align-self: flex-end;\n    padding: 10px 14px;\n    background: #383838;\n    border-radius: 999px;\n    color: #f1f1f1;\n    font-weight: 600;\n  }\n  \n  .quantity {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--wire-teal);\n    background: var(--panel-bg);\n    border-radius: 50px;\n    font-size: 12px;\n    color: #ffffff;\n    min-width: 92px;\n    padding: 2px 6px;\n    justify-content: space-between;\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);\n  }\n\n  .shopping-quantity {\n    gap: 4px;\n  }\n\n  .quantity-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 26px;\n    height: 26px;\n    min-width: 26px;\n    min-height: 26px;\n    margin: 0;\n    border-radius: 999px;\n    background: var(--btn-bg);\n    color: var(--wire-teal);\n    border: 1px solid var(--wire-teal);\n    transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);\n  }\n\n  .quantity-button:hover {\n    background: var(--btn-bg-hover);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18), 0 0 10px rgba(168, 240, 247, 0.4);\n  }\n\n  .quantity-value {\n    min-width: 18px;\n    text-align: center;\n    font-weight: 600;\n  }\n\n  .shopping-add-button,\n  .shopping-delete-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    min-height: 32px;\n    margin: 0;\n    border-radius: 10px;\n    background: var(--btn-bg);\n    border: 1px solid var(--wire-green);\n    color: var(--wire-green);\n    transition: all 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18);\n  }\n\n  .shopping-add-button:hover {\n    background: var(--btn-bg-hover);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.18), 0 0 10px rgba(165, 243, 176, 0.4);\n  }\n\n  .shopping-delete-button {\n    border-color: var(--wire-red);\n    color: var(--wire-red);\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n  }\n\n  .shopping-delete-button:hover {\n    background: var(--btn-bg-hover);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);\n  }\n\n  .shopping-empty-state {\n    padding: 28px 18px;\n    text-align: center;\n    color: #cccccc;\n    background: var(--panel-bg);\n    border: 1px dashed var(--wire-green);\n    border-radius: 12px;\n    box-shadow: inset 0 0 0 1px rgba(165, 243, 176, 0.12);\n  }\n\n  .settings-page {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .settings-header {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 18px;\n  }\n\n  .settings-header h2 {\n    margin: 0;\n    color: #ffffff;\n  }\n\n  .settings-subtitle {\n    color: #cccccc;\n    overflow-wrap: anywhere;\n  }\n\n  .settings-section {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 14px;\n    margin-top: 12px;\n    background: var(--panel-bg);\n    border: 1px solid var(--wire-purple);\n    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);\n    border-radius: 8px;\n  }\n\n  .settings-section-title {\n    color: #ffffff;\n    font-weight: 700;\n  }\n\n  .settings-info-row {\n    display: flex;\n    justify-content: space-between;\n    gap: 12px;\n    color: #cccccc;\n  }\n\n  .settings-info-row strong {\n    color: #ffffff;\n    text-align: right;\n    overflow-wrap: anywhere;\n  }\n\n  .settings-action-link,\n  .settings-action-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    min-height: 42px;\n    padding: 9px 12px;\n    margin: 0;\n    color: #ffffff;\n    background: var(--btn-bg);\n    border: 1px solid var(--wire-purple);\n    border-radius: 8px;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18);\n  }\n\n  .settings-action-button:hover {\n    background: var(--btn-bg-hover);\n    box-shadow: inset 0 0 0 1px rgba(201, 168, 255, 0.18), 0 0 10px rgba(201, 168, 255, 0.4);\n  }\n\n  .settings-action-button:disabled {\n    cursor: default;\n    opacity: 0.55;\n    transform: none;\n    box-shadow: none;\n  }\n\n  .settings-danger-action {\n    background: rgba(244, 67, 54, 0.18);\n  }\n\n  .vault-management-row {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto;\n    gap: 10px;\n    align-items: center;\n  }\n\n  .vault-management-row .add-item-box--field {\n    margin-bottom: 0;\n  }\n\n  .vault-shared-user-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .vault-shared-user-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 10px;\n    background: #424242;\n    border-radius: 8px;\n  }\n\n  .vault-shared-user-row strong {\n    color: #ffffff;\n  }\n\n  .vault-shared-user-row div div {\n    color: #cccccc;\n    font-size: 12px;\n    overflow-wrap: anywhere;\n  }\n\n  .vault-owner-pill,\n  .vault-remove-share-button {\n    flex-shrink: 0;\n    padding: 6px 9px;\n    margin: 0;\n    border-radius: 999px;\n    font-size: 12px;\n  }\n\n  .vault-owner-pill {\n    background: rgba(76, 175, 80, 0.18);\n    color: #a5d6a7;\n  }\n\n  .vault-remove-share-button {\n    background: var(--btn-bg);\n    border: 1px solid var(--wire-red);\n    color: var(--wire-red);\n    transition: all 0.2s ease;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18);\n  }\n\n  .vault-remove-share-button:hover {\n    background: var(--btn-bg-hover);\n    color: #ffffff;\n    box-shadow: inset 0 0 0 1px rgba(255, 179, 186, 0.18), 0 0 10px rgba(255, 179, 186, 0.4);\n  }\n  \n  button {\n    background: transparent;\n    border: none;\n    margin: 3px;\n    color: #ffffff;\n  }\n  button:focus {\n    outline: 0;\n  }\n  \n  button:hover {\n    cursor: pointer;\n  }\n  \n  .completed {\n    text-decoration: line-through;\n  }\n\n  .amount {\n    display: flex;\n    align-items: center;\n    border: 1px solid var(--wire-teal);\n    background: var(--panel-bg);\n    border-radius: 50px;\n    font-size: 12px;\n    color: #ffffff;\n    min-width: 70px;\n    justify-content: center;\n    float: left;\n    box-shadow: inset 0 0 0 1px rgba(168, 240, 247, 0.18);\n  }\n\n  .shopping-amount {\n    min-width: 84px;\n    padding: 0 10px;\n  }\n\n  .list-name {\n    background: #333333;\n  }\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  * {\n    font-size: 18px;\n  }\n\n  .app-background {\n    padding: 10px;\n    min-height: 100vh;\n  }\n\n  .main-shopping-container {\n    width: 100%;\n    max-width: 720px;\n    padding: 16px;\n    margin: 0 auto;\n  }\n\n  .main-item-container {\n    padding: 15px;\n  }\n\n  .item-container {\n    padding: 14px 0;\n    gap: 12px;\n    align-items: flex-start;\n  }\n\n  .vault-item-row {\n    flex-direction: row;\n    align-items: center;\n    padding: 10px 0;\n  }\n\n  .item-details {\n    flex-shrink: 0;\n    margin-left: auto;\n  }\n\n  .delete {\n    float: none;\n  }\n\n  .grid-template-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .toolbar {\n    padding: 8px 16px;\n  }\n\n  .header h6 {\n    font-size: 16px;\n  }\n\n  .shopping-header {\n    flex-direction: column;\n  }\n\n  .shopping-summary {\n    min-width: 0;\n  }\n\n  .shopping-total {\n    align-self: stretch;\n    text-align: center;\n  }\n}\n\n@media (max-width: 480px) {\n  * {\n    font-size: 16px;\n  }\n\n  .main-shopping-container {\n    padding: 12px;\n    border-radius: 12px;\n  }\n\n  .main-item-container {\n    padding: 12px;\n  }\n\n  .add-item-box {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n  }\n\n  .item-container {\n    padding: 12px 0;\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .vault-item-row {\n    flex-direction: row;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 0;\n  }\n\n  .vault-item-actions {\n    width: auto;\n    margin-left: auto;\n  }\n\n  .vault-delete-button {\n    width: 34px;\n    height: 34px;\n    min-width: 34px !important;\n    min-height: 34px !important;\n  }\n\n  .vault-danger-zone {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .settings-info-row,\n  .vault-management-row {\n    grid-template-columns: 1fr;\n  }\n\n  .vault-shared-user-row {\n    align-items: flex-start;\n  }\n\n  .settings-info-row {\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .settings-info-row strong {\n    text-align: left;\n  }\n\n  .quantity, .amount {\n    min-width: 60px;\n    font-size: 11px;\n  }\n\n  .shopping-item-details {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .quantity-button {\n    width: 30px;\n    height: 30px;\n    min-width: 30px !important;\n    min-height: 30px !important;\n  }\n\n  .shopping-add-button,\n  .shopping-delete-button {\n    width: 34px;\n    height: 34px;\n    min-width: 34px !important;\n    min-height: 34px !important;\n  }\n\n  .selected-list-title {\n    font-size: 18px;\n    padding: 12px;\n  }\n\n  .toolbar {\n    padding: 4px 8px;\n  }\n\n  .header {\n    margin: 5px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .main-shopping-container {\n    width: min(100%, 920px);\n  }\n\n  .main-item-container {\n    padding: 25px;\n  }\n\n  .item-container {\n    padding: 18px 0;\n  }\n}\n\n/* Flexbox improvements for better responsiveness */\n.app-background {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 20px;\n  min-height: 100vh;\n}\n\n@media (max-width: 768px) {\n  .app-background {\n    padding: 10px;\n    align-items: stretch;\n  }\n}\n\n/* Grid improvements for user management */\n.grid-template-columns {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 10px;\n}\n\n.user-edit-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  padding-top: 8px;\n}\n\n.user-edit-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 12px;\n}\n\n.user-vault-picker {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 8px;\n  max-height: 180px;\n  overflow-y: auto;\n  padding: 8px;\n  background: #333333;\n  border: 1px solid #555555;\n  border-radius: 8px;\n}\n\n.user-vault-option,\n.user-access-toggle {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #ffffff;\n}\n\n.user-vault-option {\n  min-height: 38px;\n  padding: 8px 10px;\n  background: #424242;\n  border-radius: 8px;\n}\n\n.user-vault-option span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.user-access-toggle {\n  align-self: flex-start;\n  min-height: 40px;\n}\n\n.user-empty-note {\n  color: #cccccc;\n  font-size: 13px;\n  padding: 8px;\n}\n\n@media (max-width: 768px) {\n  .grid-template-columns {\n    grid-template-columns: 1fr;\n  }\n\n  .user-edit-grid {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n\n  .user-vault-picker {\n    grid-template-columns: 1fr;\n    max-height: 220px;\n  }\n}\n\n/* User Management specific responsive styles */\n@media (max-width: 768px) {\n  .user-item-container {\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 15px !important;\n  }\n\n  .user-item-buttons {\n    width: 100% !important;\n    justify-content: center !important;\n    flex-wrap: wrap !important;\n    gap: 8px !important;\n  }\n\n  .user-item-buttons button {\n    flex: 1 !important;\n    min-width: 120px !important;\n  }\n}\n\n/* Button responsiveness */\n.vault-add-button, button {\n  transition: all 0.2s ease;\n}\n\n.vault-add-button:hover, button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n/* Form input improvements */\n.add-item-input:focus {\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n/* Loading spinner responsiveness */\n@media (max-width: 480px) {\n  .MuiCircularProgress-root {\n    width: 40px !important;\n    height: 40px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
